import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Decision, Service, Languages, AttachmentType, ErrorsEnum } from 'src/app/shared/models/enums.model';
import { AdminDecisionServiceDTO } from '../../models/admin-decision-DTO.model';
import { Attachment } from 'src/app/front-user/shared/models/attachment.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AdminDecisionService } from '../../services/admin-decision.service';
import { BaseRequestService } from '../../services/base-request.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { fileService } from 'src/app/front-user/shared/services/file.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
//import { disableDebugTools } from '../../../../../../node_modules/@angular/platform-browser';
import { FileValidator } from 'src/app/front-user/shared/validator/file-input.validator';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { AppConfig } from 'src/app/shared/services/app.config';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-admin-decision',
  templateUrl: './admin-decision.component.html',
  styleUrls: ['./admin-decision.component.css']
})
export class AdminDecisionComponent implements OnInit {
  adminDecisionForm: FormGroup;
  model: AdminDecisionServiceDTO;
  submitted = false;
  decision = Decision;
  decisionKeys = Object.keys(this.decision);
  testedDiv: number;
  loading = false;
  attachments: Attachment[] = [];
  responseObject: ResponseObject;
  requestId: any;
  baseRequestDTO: BaseRequest;
  serviceType = Service;
  error =  ErrorsEnum;
  serviceTypeKeys = Object.keys(this.serviceType);
  displayedLang: string;
  currentDate = new Date();
  TechnicalProgress: number;
  baseRequestId: any;
  requestMode: string;
  adminDecisionId: any;
  TechnicalAndFinantialOfferURL;
  userDecision = Decision;
  numberRegex: string = '^[0-9]*$';
  greaterThanZeroRegex: string = '^[1-9][0-9]*$';
  showRequest = true;
  isErrorMessage: boolean = false;
  // fractionRegex:string = '^[0-9]+(\.[0-9]{1,2})?$';
  fractionRegex: string = '^((([0-9])*)((\\.[0-9]{1,7})?)|([0-9])+((\\.[0-9]{1,7}))|([0-9])+((\\.)))$';
  isRequestHistory: boolean = false;
  lockTaskErrorMessage : boolean = false;
  @Input() IsReadOnly: boolean;


  constructor(private formBuilder: FormBuilder,
    private adminDecisionService: AdminDecisionService,
    private baseRequestService: BaseRequestService,
    private translate: TranslateService,
    private globalSrv: GlobalServices,
    private fileService: fileService,
    private route: ActivatedRoute,
    private global: GlobalServices,
    private alertService: AlertService,
    private authSrevice: AuthenticationService
  ) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId){
      this.baseRequestId = history.state.data.requestId;
    } else {
      window.history.back();
    }
    // this.baseRequestId = this.route.snapshot.params.Id;
    this.requestMode = this.route.snapshot.routeConfig.path;
    this.getBaseRequest();
  }

  ngOnInit() {
    if (history.state.data && history.state.data.isCompleted) {
      this.IsReadOnly = true;
    }

    this.buildForm();
  }

  buildForm() {
    this.adminDecisionForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });
  }

  BuildControls(decisionValue) {
    if (decisionValue == Decision.Accept) {
      this.adminDecisionForm.addControl('RequiredDays', new FormControl(''));
      this.adminDecisionForm.addControl('ServiceCost', new FormControl('', [Validators.required, /*Validators.pattern(this.fractionRegex)*/]));
      if (this.baseRequestDTO.ServiceId == Service.FiberGlass) {
        this.adminDecisionForm.addControl('TechnicalAndFinantialOffer', new FormControl('', [FileValidator.validate]));
        this.adminDecisionForm.addControl('ValidDate', new FormControl('', [Validators.required]));
        this.adminDecisionForm.addControl('Remarks', new FormControl(''));
      }
      if (this.baseRequestDTO.ServiceId == Service.DynamicBalancing ||
        this.baseRequestDTO.ServiceId == Service.HardnessTest ||
        this.baseRequestDTO.ServiceId == Service.NonDestructiveTestingWork) {
        this.adminDecisionForm.addControl('NearestAvailableTime', new FormControl(''));
      }
      if (this.adminDecisionForm.controls['RejectionReasons'])
        this.adminDecisionForm.removeControl('RejectionReasons');
      if (this.adminDecisionForm.controls['Comments'])
        this.adminDecisionForm.removeControl('Comments');
    }
    else if (decisionValue == Decision.Reject) {
      this.adminDecisionForm.addControl('RejectionReasons', new FormControl('', [Validators.required, Validators.maxLength(500)]));
      this.adminDecisionForm.addControl('Comments', new FormControl('', [Validators.maxLength(500)]));
      if (this.adminDecisionForm.controls['RequiredDays'])
        this.adminDecisionForm.removeControl('RequiredDays');
      if (this.adminDecisionForm.controls['NearestAvailableTime'])
        this.adminDecisionForm.removeControl('NearestAvailableTime');
      if (this.adminDecisionForm.controls['ServiceCost'])
        this.adminDecisionForm.removeControl('ServiceCost');
      if (this.adminDecisionForm.controls['TechnicalAndFinantialOffer'])
        this.adminDecisionForm.removeControl('TechnicalAndFinantialOffer');
      if (this.adminDecisionForm.controls['ValidDate'])
        this.adminDecisionForm.removeControl('ValidDate');
      if (this.adminDecisionForm.controls['Remarks'])
        this.adminDecisionForm.removeControl('Remarks');
    }
    this.testedDiv = decisionValue;
  }

  changeDecision(value) {
    this.adminDecisionForm.controls['Decision'].setValue(value);
    this.BuildControls(value);
  }

  public async onFileSelected(event,currFormControl, docName, attachmentType: AttachmentType, progressVariableName, key) {
    this[progressVariableName] = 0;
    this.alertService.clear();
    let localizationKeyValue = await this.translate.get(key).toPromise();
    if (!this.fileService.IsFileExtentionValid(event)) {
      currFormControl.setValue('');
      const formControlName = event.target.attributes.formControlName.value;
      this.adminDecisionForm.controls[formControlName].setValue('');
      var errorMessage = await this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessage);
      let invalidElements = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      // if (invalidElements && invalidElements.length>0) {
      //   invalidElements[0].scrollIntoView();
      // }
      return false;
    }

    else if (!this.fileService.IsFileSizeValid(event)) {
      currFormControl.setValue('');
      const formControlName = event.target.attributes.formControlName.value;
      this.adminDecisionForm.controls[formControlName].setValue('');
      var errorMessage = await this.translate.get('FRONT_USER.NotAllowedFileSize').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessage);
      let invalidElement = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      // if (invalidElement && invalidElement.length>0) {
      //   invalidElement[0].scrollIntoView();
      // }
      return false;

    }
    else {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('File', file);
      formData.append('DocumentName', docName);
      formData.append('FolderName', AppConfig.settings.apiServer.ShipyardUploadsFolder);
      this.fileService.fileUploader(formData).subscribe(
        event => {

          if (event.type === HttpEventType.UploadProgress) {
            // This is an upload progress event. Compute and show the % done:
            const percentDone = Math.round(100 * event.loaded / event.total);

            // console.log(`File is ${percentDone}% uploaded.`);


            this[progressVariableName] = percentDone;
            currFormControl.setErrors({ 'invalid': true });

          } else if (event instanceof HttpResponse) {
            currFormControl.setErrors(null);
            const jsonResponse = event.body.Data;
            const Url = jsonResponse.Url;
            const attachment = new Attachment();
            attachment.URL = Url;
            attachment.DocumentName = docName;
            attachment.AttachmentTypeId = attachmentType;
            this.attachments = this.attachments.filter(h => h.DocumentName != docName);
            this.attachments.push(attachment);
          }
        }
      );
    }
  }

  getBaseRequest() {
    this.requestId = this.baseRequestId;
    this.baseRequestService.getBaseRequest(this.requestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        if (this.IsReadOnly) {
          this.getAdminDecision();
        }
      }
    )
  }

  getAdminDecision() {
    this.adminDecisionService.getAdminDecision(this.baseRequestId).subscribe(
      d => {
        this.model = d.Data;
        this.BuildControls(this.model.Decision);
        this.adminDecisionId = this.model.Id;
        this.adminDecisionForm.patchValue({
          Decision: this.model.Decision,
          RequiredDays: this.model.RequiredDays,

          NearestAvailableTime: this.model.NearestAvailableTime!=null?new Date(this.model.NearestAvailableTime):'',

          ServiceCost: this.model.ServiceCost,
          TechnicalAndFinantialOffer: this.model.TechnicalAndFinantialOffer,
          ValidDate: this.model.ValidDate!=null?new Date(this.model.ValidDate):'',
          Remarks: this.model.Remarks,
          RejectionReasons: this.model.RejectionReasons,
          Comments: this.model.Comments
        });
        var baseUrl = AppConfig.settings.apiServer.UploadsUrl;
        var shipyardUploadsFolder = AppConfig.settings.apiServer.ShipyardUploadsFolder;

        this.TechnicalAndFinantialOfferURL = this.model.Attachments.find(x => x.AttachmentType == AttachmentType.TechnicalAndFinantialOffer) != undefined ?
          this.model.Attachments.find(x => x.AttachmentType == AttachmentType.TechnicalAndFinantialOffer).URL : '';
        this.TechnicalAndFinantialOfferURL = baseUrl + shipyardUploadsFolder + "/" + this.TechnicalAndFinantialOfferURL;
      }

    );


  }

  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.adminDecisionForm.invalid) {
      return;
    }
    //Enable Loader
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.model = this.adminDecisionForm.getRawValue();
    this.model.BaseRequestId = this.baseRequestId;
    this.model.AdminEmail = this.authSrevice.currentUserValue.UserName;
    this.model.RequestorId = this.authSrevice.currentUserValue.UserId;
    this.model.serviceId = this.baseRequestDTO.Service.Id;
    this.model.Attachments = this.attachments;
    this.model.TechnicalAndFinantialOffer = this.attachments.length !== 0 ? this.attachments[0].URL : "";
    this.adminDecisionService.addAdminDecision(this.model).subscribe(
      (data: ResponseObject) => {

        this.responseObject = data;

        if (this.responseObject.Success) {
          this.adminDecisionForm.reset();
          this.loading = false;
          this.showRequest = false;
          //Disable Loader
          this.globalSrv.isLoaderEnabled = false;
        } else if( this.responseObject.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser")!=null) {
          this.lockTaskErrorMessage = true;
          this.showRequest = false;
          //Disable Loader
          this.globalSrv.isLoaderEnabled = false;
        }
        else{
          this.loading = false;
          this.isErrorMessage = true;
          this.showRequest = false;
          //Disable Loader
          this.globalSrv.isLoaderEnabled = false;
        }
      });
  }

  get f() {
    return this.adminDecisionForm.controls;
  }
}
